import { axiosInstance } from 'lib/api/v2'
import useSWR from 'swr'

type UseSurveyAnswerRequest = {
  surveyType: Enum.CorporateSurveyType
}

/**
 * Keep the default axios status validation, but allow 404 status (when there is no survey answer).
 */
function validateStatus(status: number) {
  return (status >= 200 && status < 300) || status === 404
}

async function fetcher([, params]: [unknown, UseSurveyAnswerRequest]) {
  return axiosInstance.get<Model.CorporateSurveyAnswer>('private/surveys', {
    params,
    validateStatus
  })
}

export const useSurveyAnswer = (params: UseSurveyAnswerRequest) =>
  useSWR(['getSurveyAnswer', params], fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false
  })
